import { TYPES } from "./default_supporter.type";
import { onSnapshot, query, where, getDocs } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApiFunctions } from "store/user/api";
import { getAuth } from "firebase/auth";
import { getApp } from "firebase/app";
import { PROJECT_ID } from "config/keys/user";

const app = getApp(PROJECT_ID);
const auth = getAuth(app);

// ========= firebase function =========//
export const addDefaultSupporter =
  ({ id, supporters, note }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().manager.addSupporters;
    const options = { id, supporters, note };

    console.log({ options });

    functions(options)
      .then(() => {
        if (callback) {
          callback({ status: 200 });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Some errors happened!",
          });
        }
      });
  };

export const updateDefaultSupporter =
  ({ id, supporters }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().manager.updateSupporters;
    const options = { id, supporters };

    console.log({ id, supporters });

    functions(options)
      .then(() => {
        if (callback) {
          callback({ status: 200 });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Some errors happened!",
          });
        }
      });
  };

//delete multiple
export const deleteDefaultSupporter =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().manager.deleteSupporters;
    const options = { id };

    functions(options)
      .then(() => {
        if (callback) {
          callback({ status: 200 });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Some errors happened!",
          });
        }
      });
  };

//snap all provider
const allDefaultSupporterSub = [];
export const snapDefaultSupporter = (callback) => (dispatch) => {
  setDefaultSupporterAllSuccess(dispatch, null);
  const cRef = getRefs().supporter;
  const uid = auth?.currentUser?.uid;
  console.log({ uid });
  const c0 = where("manager", "==", uid);
  const qRef = query(cRef, c0);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      setDefaultSupporterAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultSupporterSub.push(unsub);
};

export const unSnapDefaultSupporter = () => (dispatch) => {
  allDefaultSupporterSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultSupporterSub.length = 0;
};

// handle search by email.
export const setSearchByEmail =
  ({ email }) =>
  (dispatch) => {
    setDefaultSupporterInfoSuccess(dispatch, null);
    const cRef = getRefs().user;
    const c0 = where("email", "==", email);
    const qRef = query(cRef, c0);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc.data());
        const detail = data?.length > 0 ? data[0] : null;
        setDefaultSupporterInfoSuccess(dispatch, detail);
      }
    });
  };

// search cloud
export const searchEmail =
  ({ email }, callback) =>
  (dispatch) => {
    setDefaultSupporterInfoSuccess(dispatch, null);
    const functions = getApiFunctions().manager.searchUserEmail;
    const options = { email };

    console.log({ options });
    return functions(options)
      .then((res) => {
        const data = res?.data;
        setDefaultSupporterInfoSuccess(dispatch, data);
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Invalid Error!" });
      });
  };

// handle search by email.
// export const setSearchById =
//   ({ id }, callback) =>
//   (dispatch) => {
//     setDefaultSupporterInfoSuccess(dispatch, null);
//     const cRef = getRefs().user;
//     const c0 = where("id", "==", id);
//     const qRef = query(cRef, c0);
//     console.log({ id });
//     getDocs(qRef)
//       .then((snapshot) => {
//         if (snapshot) {
//           const data = snapshot?.docs?.map((doc) => doc.data());
//           const detail = data?.length > 0 ? data[0] : null;
//           if (detail) {
//             setDefaultSupporterInfoSuccess(dispatch, detail);
//             callback && callback({ status: 200 });
//           } else {
//             callback && callback({ status: 500, data: "Không đúng mã QR" });
//           }
//         }
//       })
//       .catch((err) => {
//         console.log({ err });
//         callback &&
//           callback({ status: 500, data: "Không đúng mã QR" || err?.message });
//       });
//   };

export const setSearchById =
  ({ id }, callback) =>
  (dispatch) => {
    setDefaultSupporterInfoSuccess(dispatch, null);
    const functions = getApiFunctions().manager.searchUserId;
    const options = { id };

    console.log({ options });
    return functions(options)
      .then((res) => {
        const data = res?.data;
        setDefaultSupporterInfoSuccess(dispatch, data);
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Invalid Error!" });
      });
  };

// ========= cloud function =========//
// ========= local function =========//
export const clearSupporterInfo = () => (dispatch) => {
  setDefaultSupporterInfoSuccess(dispatch, null);
};

export const setDefaultSupporterAll = (data, callback) => (dispatch) => {
  setDefaultSupporterAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultSupporterOpenAdd = (data, callback) => (dispatch) => {
  setDefaultSupporterOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultSupporterOpenEdit = (data, callback) => (dispatch) => {
  setDefaultSupporterOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultSupporterSelected = (data, callback) => (dispatch) => {
  setDefaultSupporterSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultSupporterSearch = (data, callback) => (dispatch) => {
  setDefaultSupporterSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultSupporterType = (data, callback) => (dispatch) => {
  setDefaultSupporterTypeSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultSupporterInfoSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_SUPPORTER_INFO,
    payload: data,
  });
};

const setDefaultSupporterAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_SUPPORTER_ALL,
    payload: data,
  });
};

const setDefaultSupporterOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_SUPPORTER_OPEN_ADD,
    payload: data,
  });
};

const setDefaultSupporterOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_SUPPORTER_OPEN_EDIT,
    payload: data,
  });
};

const setDefaultSupporterSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_SUPPORTER_SELECTED,
    payload: data,
  });
};

const setDefaultSupporterSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_SUPPORTER_SEARCH,
    payload: data,
  });
};

const setDefaultSupporterTypeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_SUPPORTER_TYPE,
    payload: data,
  });
};
